import { Language, ListStyle } from '@yleisradio/areena-types';
import { CardList } from '../View/viewTypes';
import { logger } from '../../common/logger';

export type GroupType = 'list' | 'grid' | 'highlight_card';
export type ListStyleSize = ListStyle['size'] | undefined;
export type ListStyleLayout = ListStyle['layout'] | undefined;

export const getGroupType = (
  contentType: CardList['listType'],
  listStyle: CardList['style']
): GroupType => {
  if (listStyle?.layout === 'grid') {
    return 'grid';
  }
  if (contentType === 'highlightCard') {
    return 'highlight_card';
  }
  if (contentType === 'list') {
    return 'list';
  }

  console.warn(
    `Unknown mapping to snowplow groupType from content.type: ${contentType} and listStyle.layout: ${listStyle?.layout}`
  );
  return 'list';
};

export const uiLanguageToSnowplowLanguage = (
  language: Language
): 'fin' | 'swe' => {
  switch (language) {
    case 'fi':
      return 'fin';
    case 'sv':
      return 'swe';
    default:
      throw new Error(`Unsupported language: ${language}`);
  }
};

export const getCustomViewIdentifier = (
  areenaApiUri: string | undefined
): string | undefined => {
  if (!areenaApiUri) return undefined;

  try {
    const custom_view_identifier = areenaApiUri
      ? new URL(areenaApiUri).pathname
      : undefined;

    if (shouldUseCustomView(custom_view_identifier)) {
      return custom_view_identifier;
    }
  } catch {
    logger.error(
      `Failed to parse areenaApiUri to custom_view_identifier from uri: ${areenaApiUri}`
    );
  }
};

const shouldUseCustomView = (custom_view_identifier: string | undefined) => {
  if (custom_view_identifier?.includes('omat.json')) return true;

  if (custom_view_identifier?.includes('live.json')) return true;

  return false;
};
